import React, {useContext, useEffect, useState} from 'react';

import {Row, Col}  from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Dropdown from "react-bootstrap/Dropdown";
import TimezoneSelect from 'react-timezone-select'
import { Link } from "react-router-dom";

import {version} from "../common/constants";
import classes from './Auth/AuthForm.module.css';
import NavigationHeader from "./Layout/NavigationHeader";
import ChangePassword from "./Admin/ChangePasswordComponent";
import Button from "react-bootstrap/Button";
import {settings_web_user_get,
        settings_web_user_set,
        settings_web_user_add
       } from "../common/BackendConnections";
import AuthContext from "../store/auth-context";

const languages = ["English - EN",
                           "Français - FR",
                           "Espanol - ES"];

const fontSizeMin = 8;
const fontSizeMax = 16;

const UserSettings = (props) => {
  const [selectedLanguage, setSelectedLanguage] = useState("English - EN")
  const [selectedTimezone, setSelectedTimezone] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  )
  const [fontsize, setFontSize] = useState(12)
  const [softwareUpdate, setSoftwareUpdate] = useState(false)
  const [tipsAndSuggestions, setTipsAndSuggestions] = useState(false)
  const [feedbackEmails, setFeedbackEmails] = useState(false)
  const [reminderEmails, setReminderEmails] = useState(false)
  const [productEmails, setProductEmails] = useState(false)
  const [newsEmails, setNewsEmails] = useState(false)
  const [supportEmails, setSupportEmails] = useState(false)

  const [message, setMessage] = useState('')

  const [changePassword, setchangePassword] = useState(false)

  const authCtx = useContext(AuthContext);

  useEffect(() => {
    settings_web_user_get(authCtx.userId).then((response) => {
        if ( response.status === 200 ) {
          setSelectedLanguage( response.data.locale_code )
          setSelectedTimezone( response.data.time_zone )
          setFontSize( response.data.accessibility_settings.font_size )
          setSoftwareUpdate( response.data.notification_settings.software_update )
          setTipsAndSuggestions( response.data.notification_settings.tips )
          setFeedbackEmails( response.data.notification_settings.email_feedback )
          setReminderEmails( response.data.notification_settings.email_reminder )
          setProductEmails( response.data.notification_settings.email_product )
          setNewsEmails( response.data.notification_settings.email_news )
          setSupportEmails( response.data.notification_settings.email_support )
        }
      }
    ).catch((error) => {
      // if pre-defined user settings not found, add default ones
      if ( error.response.status === 404 ) {
        const data = {
          user_id: authCtx.userId,
          locale_code: selectedLanguage,
          time_zone: selectedTimezone,
          accessibility_settings: {
            font_size: fontsize
          },
          notification_settings: {
            software_update: softwareUpdate,
            tips: tipsAndSuggestions,
            email_feedback: feedbackEmails,
            email_reminder: reminderEmails,
            email_product: productEmails,
            email_news: newsEmails,
            email_support: supportEmails
          }
        }
        settings_web_user_add(data).then((response) => {
            if ( response.status === 200 ) {
              setMessage({text: 'No user settings were pre-defined, assuming default values', isError: false})
            }
          }
        ).catch((error) => {
          console.log(error);
          setMessage({text: 'Error: Unable to add user settings values', isError: true})
        });
      }
    });
  }, []);

  const handleSaveSettings = () => {
    const data = {
      locale_code: selectedLanguage,
      time_zone: selectedTimezone,
      accessibility_settings: {
        font_size: fontsize
      },
      notification_settings: {
        software_update: softwareUpdate,
        tips: tipsAndSuggestions,
        email_feedback: feedbackEmails,
        email_reminder: reminderEmails,
        email_product: productEmails,
        email_news: newsEmails,
        email_support: supportEmails
      }
    }
    settings_web_user_set(authCtx.userId, data).then((response) => {
        if ( response.status === 200 ) {
          setMessage({text: 'Saving user settings ... Done', isError: false})
        }
      }
    ).catch((error) => {
      console.log(error);
      setMessage({text: 'Error: unable to save user settings', isError: true})
    });
  }

  const handleDefaultSettings = () => {
    setSelectedLanguage( "English - EN")
    setSelectedTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone)
    setFontSize( 12)
    setSoftwareUpdate( true)
    setTipsAndSuggestions( true)
    setFeedbackEmails( false)
    setReminderEmails( false)
    setProductEmails( false)
    setNewsEmails( false)
    setSupportEmails( false)
    setMessage( {text: 'Default User settings has been applied', isError: false} )
  }

  const handleTimeZone = (e) => {
    setSelectedTimezone(e.value)
  }

  const handlechangePassword = () => {
    setchangePassword(true)
  }

  return (
    <div className={"page_content"}>
      <NavigationHeader />

      <div>
        <h1>Settings</h1>

        <section>
          <Row>
          <Col xs={2}>
            <label>Language</label>
          </Col>
          <Col xs={{offset:2, span:6}}>
            <div className={classes.control}>
              <Dropdown className={"dropdown-style"} style={{width:'100%'}}>
                <Dropdown.Toggle className={"dropdown-contents-style"}
                                 variant="custom"
                                 id="dropdown-basic">
                  {selectedLanguage}
                  <span style={{marginRight: '3ch'}}/>
                </Dropdown.Toggle>

                <Dropdown.Menu  className="dropdown-menu-items-style">
                  {languages.map((language, index) => (
                    <Dropdown.Item key={index}
                                   onClick={() => setSelectedLanguage(language)}>
                      {language}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>
          </Row>
        </section>
        <hr/>

        <section>
          <Row>
            <Col xs={2}>
              <label>Time Zone</label>
            </Col>
            <Col xs={{offset:2, span:6}}>
            <span className="select-wrapper">
              <TimezoneSelect
                value={selectedTimezone}
                onChange={handleTimeZone}
              />
            </span>
            </Col>
          </Row>
        </section>
        <hr/>

        {/*<section>*/}
        {/*  <h2>Accessibility</h2>*/}
        {/*    <Row>*/}
        {/*      <Col xs={2}>*/}
        {/*        Text Size*/}
        {/*      </Col>*/}
        {/*      <Col md={{offset:2, span:4}}>*/}
        {/*        <div className="rangeValues">Range : {fontSizeMin} - {fontSizeMax}, Selected Value = {fontsize}</div>*/}
        {/*        <input type={"range"} value={fontsize} min={fontSizeMin} max={fontSizeMax} step={1}*/}
        {/*               onChange={(e) => setFontSize(e.target.value)}></input>*/}
        {/*      </Col>*/}
        {/*    </Row>*/}
        {/*</section>*/}
        {/*<hr/>*/}

        <section>
          <h2>Notifications</h2>

          <Row>
            <Col xs={4}>
              Software Updates
            </Col>
            <Col>
              <Form.Switch checked={softwareUpdate}
                           onChange={(e) => {
                                      setSoftwareUpdate(e.target.checked)
                           }
              }/>
            </Col>

            <Col xs={4}>
              Feedback Emails
            </Col>
            <Col>
              <Form.Check checked={feedbackEmails}
                          onChange={(e) => {
                            setFeedbackEmails(e.target.checked)
                          }
                          }/>
            </Col>
          </Row>

          <Row>
            <Col xs={4}>
              Tips and Suggestions
            </Col>
            <Col>
              <Form.Switch checked={tipsAndSuggestions}
                           onChange={(e) => {
                                      setTipsAndSuggestions(e.target.checked)
                           }
              }/>
            </Col>

            <Col xs={4}>
              Reminder Emails
            </Col>
            <Col>
              <Form.Check checked={reminderEmails}
                          onChange={(e) => {
                            setReminderEmails(e.target.checked)
                          }
              }/>
            </Col>
          </Row>

          <Row>
          </Row>
          <Row>
            <Col xs={{offset:6,span:4}}>
              Product Emails
            </Col>
            <Col>
              <Form.Check checked={productEmails}
                          onChange={(e) => {
                                     setProductEmails(e.target.checked)
                          }
              }/>
            </Col>
          </Row>
          <Row>
            <Col xs={{offset:6,span:4}}>
              News Emails
            </Col>
            <Col>
              <Form.Check checked={newsEmails}
                          onChange={(e) => {
                                     setNewsEmails(e.target.checked)
                          }
              }/>
            </Col>
          </Row>
          <Row>
            <Col xs={{offset:6,span:4}}>
              Support Emails
            </Col>
            <Col>
              <Form.Check checked={supportEmails}
                          onChange={(e) => {
                                     setSupportEmails(e.target.checked)
                          }
              }/>
            </Col>
          </Row>
        </section>
        <hr/>

        <section>
          <Row>
            <Col xs={{offset:0,span:0}}>
              <h2>Change Password</h2>
            </Col>
            <Col xs={{offset:0,span:0}}>
              <button id="updatePassword" className={"updatePassword-Button"} onClick={handlechangePassword}>
                {"Change"}
              </button>
            </Col>
          </Row>
          { changePassword &&
              <ChangePassword show={true}
                              handleFormExit={ () => {
                                setchangePassword(false) }
                              }
              />
          }
        </section>
        <hr/>

        <section>
          <h2>About</h2>
          <div>Software Version: <strong>{version}</strong></div>
        </section>
        <hr/>

        <div>
          {message.text && !message.isError && <div className={"normal_message"}>{message.text}</div> }
          {message.text &&  message.isError && <div className={"error_message"}>{message.text}</div> }
        </div>

        <section>
          <Row>
            <Col xs={{offset:0,span:0}}>
              <Button color="failure" onClick={handleSaveSettings}>Save Settings</Button>
            </Col>
            <Col xs={{offset:0,span:0}}>
              <Button color="failure" onClick={handleDefaultSettings}>Default Settings</Button>
            </Col>
          </Row>
        </section>

        <section>
          <Link to={"/learnmore/"}> Learn More </Link> <br/>
          <Link to={"/privacy/"}> Privacy and Cookies </Link> <br/>
          <Link to={"/termsofuse/"}> Terms of Use </Link> <br/>
          <div>
            UNLTD Copyright @ 2022
          </div>
        </section>
      </div>
    </div>
  );
}

export default UserSettings;
